<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :title="title"
    width="40%"
    append-to-body
  >
    <div class="SiruiModalHeight">
      <!--内容区域-->
      <!-- 添加v-if="showTable"解决打开弹出框列错位问题 -->
      <vxe-grid
        border
        show-overflow
        resizable
        ref="siruiTable"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        @handleSizeChange="handleSizeChange"
        :checkbox-config="{ checkMethod: radioCanCheck }"
        :radio-config="{ checkMethod: radioCanCheck }"
        height="300"
      >
        <vxe-table-column
          v-if="!isRadio"
          type="checkbox"
          :title="$t('search.radio')"
          width="50"
          fixed="left"
        ></vxe-table-column>
        <vxe-table-column
          v-else
          type="radio"
          :title="$t('search.radio')"
          width="50"
          fixed="left"
        ></vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :field="item.prop"
          :title="item.label"
        >
          <template v-slot="{ row }">
            <span v-if="item.prop == 'partnerType'">
              {{ getLabel('partner_type', row[item.prop]) }}</span
            >
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
    <div class="search-modal-footer">
      <el-button type="primary" @click="confirmHandler">
        <span class="footer-button">{{ confirmText }}</span>
      </el-button>
      <el-button @click="cancelHandler">
        <span class="footer-button">{{ $t('dialog.cancel') }}</span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';

  export default {
    name: 'SelectPartnerDialog',
    mixins: [IntermodalityCommonMixin],
    components: {},
    props: {
      title: {
        type: String,
        default: () => '项目转合同-选择项目中合作伙伴',
      },
      confirmText: {
        type: String,
        default: () => '确认',
      },
      isRadio: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        dialogVisible: false,
        showTable: false,
        load: false,
        tableData: [],
        query: {
          pageSize: 10,
          pageNum: 1,
          projectCode: '',
          //0上游1下游
          isUpOrDown: '0',
        },
      };
    },

    mounted() {},

    computed: {
      columnList() {
        if (this.query.isUpOrDown == '0') {
          return [
            {
              prop: 'upPartnerName',
              label: '合作伙伴名称',
              width: 150,
            },
            {
              prop: 'upPartnerCode',
              label: '合作伙伴编码',
              width: 150,
            },
            {
              prop: 'upPartherType',
              label: '合作伙伴类别',
              width: 150,
            },
          ];
        } else {
          return [
            {
              prop: 'downPartnerName',
              label: '合作伙伴名称',
              width: 150,
            },
            {
              prop: 'downPartnerCode',
              label: '合作伙伴编码',
              width: 150,
            },
            {
              prop: 'dowmPartherType',
              label: '合作伙伴类别',
              width: 150,
            },
          ];
        }
      },
    },
    watch: {
      dialogVisible(value) {
        if (value) {
          this.showTable = true;
        }
      },
    },
    methods: {
      radioCanCheck({ row }) {
        return row.flagConversionContract != 1;
      },
      async fetchData() {
        if (this.$refs.siruiTable) {
          this.query.pageSize = this.$refs.siruiTable.page.pageSize;
          this.query.pageNum = this.$refs.siruiTable.page.pageNum;
        } else {
          this.query.pageSize = 10;
          this.query.pageNum = 1;
        }

        let res;
        res = await this.$axios.post('/sales/mtoProject/getCooperativeParther', this.query);
        if (res && res.data.code == 0) {
          this.tableData = res.data.data;
          // this.$refs.siruiTable.setPageTotal(res.total);
          // this.$refs.siruiTable.reloadTable(this.tableData);
        } else {
          this.$message.error(res.data?.msg);
        }
      },
      handleSizeChange() {
        this.fetchData();
      },
      //第几页
      handleCurrentChange() {
        this.fetchData();
      },
      openModal(projectCode, isUpOrDown = '0') {
        this.query.projectCode = projectCode;
        this.query.isUpOrDown = isUpOrDown;
        this.dialogVisible = true;
        this.fetchData();
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      confirmHandler() {
        let selection = this.isRadio
          ? this.$refs.siruiTable.getRadioRecord()
          : this.$refs.siruiTable.getCheckboxRecords();
        if (selection) {
          this.$emit('confirm', selection, this.query);
          this.cancelHandler();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  $maintheme: #409eff;

  .search-modal-footer {
    margin-top: 15px;
    text-align: center;
  }

  .el-button {
    border-radius: 2px;
  }

  .el-button--primary {
    background-color: $maintheme;
    border-color: $maintheme;
  }

  .SiruiModalHeight {
    max-height: 400px;
    // overflow-y: auto;
    // overflow-x: hidden;
  }

  ::v-deep .vxe-table--body-wrapper {
    height: 180px !important;
  }

  // .sirui-table .vxe-toolbar[data-v-3c6ed471]
  .SiruiModalHeight {
    ::v-deep .sirui-table .vxe-toolbar {
      display: none !important;
    }
  }
</style>
